module.exports = __webpack_public_path__ + "img/0438144c4e551df3b6ecdfdd40255b7e.svg";